// import React from 'react';
// import './barchart.css';

// import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
// import { Paper, Typography, Box } from "@mui/material";

// const COLORS = [
//   "#1976d2", 
//   "#ef6c00", 
//   "#388e3c", 
//   "#d32f2f", 
//   "#7b1fa2", 
//   "#fbc02d", 
//   "#0097a7", 
//   "#5d4037", 
// ];

// const MonthlyComparisonChart = ({ data }) => {
//   const months = [
//     "January", "February", "March", "April", "May", "June",
//     "July", "August", "September", "October", "November", "December"
//   ];

//   const uniqueYears = [...new Set(data.map(item => item.salesYear))].sort();

//   const transformData = (data) => {
//     const monthMap = {};

//     data.forEach((item) => {
//       const monthName = months[item.salesMonth - 1];
//       if (!monthMap[monthName]) {
//         monthMap[monthName] = { month: monthName };
//       }
//       monthMap[monthName][item.salesYear] = item.totalSales;
//     });

//     return months
//       .filter((m) => monthMap[m]) 
//       .map((m) => monthMap[m]);
//   };

//   const chartData = transformData(data);

//   return (
//     <Box sx={{ width: 950, marginTop: '20px' }}>
//       <Paper elevation={0} sx={{ p: 3, border: '1px solid #ccc', borderRadius: 2 }}>
//         <Typography variant="h6" gutterBottom>
//           Yearly Monthly Sales Comparison
//         </Typography>

//         <ResponsiveContainer width="100%" height={145}>
//           <BarChart margin={{ left: 20, bottom: 5 }} data={chartData}>
//             <XAxis
//               dataKey="month"
//               tick={{ fontSize: 12 }}
//             />
//             <YAxis
//               ticks={[0, 200000, 400000, 1000000]}
//               domain={[0, 1000000]}
//               tickFormatter={(value) => value.toLocaleString('en-IN')}
//             />
//             <Tooltip
//               formatter={(value) => value.toLocaleString('en-IN')}
//             />
//             {uniqueYears.map((year, index) => (
//               <Bar
//                 key={year}
//                 dataKey={year}
//                 fill={COLORS[index % COLORS.length]}
//                 name={`${year} Sales`}
//               />
//             ))}
//           </BarChart>
//         </ResponsiveContainer>
//       </Paper>
//     </Box>
//   );
// };

// export default MonthlyComparisonChart;









// import React from 'react';
// import './barchart.css';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
// import { Paper, Typography, Box } from "@mui/material";

// const COLORS = [
//   "#1976d2", // Blue
//   "#ef6c00", // Orange
//   "#388e3c", // Green
//   "#d32f2f", // Red
//   "#7b1fa2", // Purple
//   "#fbc02d", // Yellow
//   "#0097a7", // Teal
//   "#5d4037", // Brown
// ];

// const MonthlyComparisonChart = ({ data }) => {
//   const months = [
//     "January", "February", "March", "April", "May", "June",
//     "July", "August", "September", "October", "November", "December"
//   ];

//   const uniqueYears = [...new Set(data.map(item => item.salesYear))].sort();

//   const transformData = (data) => {
//     const monthMap = {};
//     data.forEach((item) => {
//       const monthName = months[item.salesMonth - 1];
//       if (!monthMap[monthName]) {
//         monthMap[monthName] = { month: monthName };
//       }
//       monthMap[monthName][item.salesYear] = item.totalSales;
//     });

//     return months
//       .filter((m) => monthMap[m]) 
//       .map((m) => monthMap[m]);
//   };

//   const chartData = transformData(data);

//   return (
//     <Box sx={{ width: "100%", marginTop: '20px' }}>
//       <Paper elevation={3} sx={{ p: 3, borderRadius: 2, boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
//         <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "#333" }}>
//           Yearly Monthly Sales Comparison
//         </Typography>

//         <ResponsiveContainer width="100%" height={300}>
//           <BarChart margin={{ left: 20, right: 20, bottom: 5 }} data={chartData}>
//             <XAxis
//               dataKey="month"
//               tick={{ fontSize: 12, fill: "#666" }}
//               tickLine={{ stroke: "#ddd" }}
//             />
//             <YAxis
//               ticks={[0, 200000, 400000, 1000000]}
//               domain={[0, 1000000]}
//               tickFormatter={(value) => value.toLocaleString('en-IN')}
//               tickLine={{ stroke: "#ddd" }}
//             />
//             <Tooltip
//               formatter={(value) => value.toLocaleString('en-IN')}
//               contentStyle={{ backgroundColor: "#fff", border: "1px solid #ccc", borderRadius: "5px" }}
//             />
//             <Legend
//               verticalAlign="top"
//               height={36}
//               iconType="circle"
//               wrapperStyle={{ lineHeight: "40px", fontSize: "12px", color: "#333" }}
//             />
//             {uniqueYears.map((year, index) => (
//               <Bar
//                 key={year}
//                 dataKey={year}
//                 fill={COLORS[index % COLORS.length]}
//                 name={`${year} Sales`}
//                 barSize={20} // Controls the thickness of the bars
//                 radius={[10, 10, 0, 0]} // Rounded top corners of bars
//                 isAnimationActive={false}
//               />
//             ))}
//           </BarChart>
//         </ResponsiveContainer>
//       </Paper>
//     </Box>
//   );
// };

// export default MonthlyComparisonChart;



// import React from 'react';
// import './barchart.css';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
// import { Paper, Typography, Box } from "@mui/material";

// const COLORS = [
//   "#1976d2", 
//   "#ef6c00", 
//   "#388e3c", 
//   "#d32f2f", 
//   "#7b1fa2", 
//   "#fbc02d", 
//   "#0097a7", 
//   "#5d4037", 
// ];

// // const MonthlyComparisonChart = ({ data }) => {
// //   const months = [
// //     "January", "February", "March", "April", "May", "June",
// //     "July", "August", "September", "October", "November", "December"
// //   ];

// //   const uniqueYears = [...new Set(data.map(item => item.salesYear))].sort();

// //   const transformData = (data) => {
// //     const monthMap = {};
// //     data.forEach((item) => {
// //       const monthName = months[item.salesMonth - 1];
// //       if (!monthMap[monthName]) {
// //         monthMap[monthName] = { month: monthName };
// //       }
// //       monthMap[monthName][item.salesYear] = item.totalSales;
// //     });

// //     return months
// //       .filter((m) => monthMap[m]) 
// //       .map((m) => monthMap[m]);
// //   };

// //   const chartData = transformData(data);

// //   return (
// //     <Box sx={{ width: "100%"}}>
// //       <Paper elevation={3} sx={{ p: 3, borderRadius: 2, boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
// //         <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "#333" }}>
// //           Sales Comparison
// //         </Typography>

// //         <ResponsiveContainer width="100%" height={300}>
// //           <BarChart margin={{ left: 20, right: 20, bottom: 5 }} data={chartData}>
// //             <XAxis
// //               dataKey="month"
// //               tick={{ fontSize: 12, fill: "#666" }}
// //               tickLine={{ stroke: "#ddd" }}
// //             />
// //             <YAxis
// //               ticks={[0, 200000, 400000, 1000000]}
// //               domain={[0, 1000000]}
// //               tickFormatter={(value) => value.toLocaleString('en-IN')}
// //               tickLine={{ stroke: "#ddd" }}
// //             />
// //             <Tooltip
// //               formatter={(value) => value.toLocaleString('en-IN')}
// //               contentStyle={{ backgroundColor: "#fff", border: "1px solid #ccc", borderRadius: "5px" }}
// //             />
// //             <Legend
// //               verticalAlign="top"
// //               height={36}
// //               iconType="circle"
// //               wrapperStyle={{ lineHeight: "40px", fontSize: "12px", color: "#333" }}
// //             />
// //             {uniqueYears.map((year, index) => (
// //               <Bar
// //                 key={year}
// //                 dataKey={year}
// //                 fill={COLORS[index % COLORS.length]}
// //                 name={`${year} Sales`}
// //                 barSize={20} 
// //                 radius={[10, 10, 0, 0]} 
// //                 isAnimationActive={false}
// //               />
// //             ))}
// //           </BarChart>
// //         </ResponsiveContainer>
// //       </Paper>
// //     </Box>
// //   );
// // };

// const MonthlyComparisonChart = ({ data }) => {
//   // Financial year months in order (Apr to Mar)
//   const months = [
//     "April", "May", "June", "July", "August", "September",
//     "October", "November", "December", "January", "February", "March"
//   ];

//   const uniqueYears = [...new Set(data.map(item => item.salesYear))].sort();

//   const transformData = (data) => {
//     const monthMap = {};
    
//     data.forEach((item) => {
//       const monthName = months[item.salesMonth - 1];
      
//       if (!monthMap[monthName]) {
//         monthMap[monthName] = { month: monthName };
//       }
      
//       monthMap[monthName][item.salesYear] = item.totalSales;
//     });

//     // Return months in financial year order
//     return months
//       .filter(m => monthMap[m])
//       .map(m => monthMap[m]);
//   };

//   const chartData = transformData(data);

//   return (
//     <Box sx={{ width: "100%" }}>
//       <Paper elevation={3} sx={{ p: 3, borderRadius: 2, boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
//         <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "#333" }}>
//           Sales Comparison (Financial Year)
//         </Typography>

//         <ResponsiveContainer width="100%" height={300}>
//           <BarChart margin={{ left: 20, right: 20, bottom: 5 }} data={chartData}>
//             <XAxis
//               dataKey="month"
//               tick={{ fontSize: 12, fill: "#666" }}
//               tickLine={{ stroke: "#ddd" }}
//             />
//             <YAxis
//               ticks={[0, 200000, 400000, 1000000]}
//               domain={[0, 1000000]}
//               tickFormatter={(value) => value.toLocaleString('en-IN')}
//               tickLine={{ stroke: "#ddd" }}
//             />
//             <Tooltip
//               formatter={(value) => value.toLocaleString('en-IN')}
//               contentStyle={{ backgroundColor: "#fff", border: "1px solid #ccc", borderRadius: "5px" }}
//             />
//             <Legend
//               verticalAlign="top"
//               height={36}
//               iconType="circle"
//               wrapperStyle={{ lineHeight: "40px", fontSize: "12px", color: "#333" }}
//             />
//             {uniqueYears.map((year, index) => (
//               <Bar
//                 key={year}
//                 dataKey={year}
//                 fill={COLORS[index % COLORS.length]}
//                 name={`FY ${year}-${(year + 1).toString().slice(-2)}`}
//                 barSize={20}
//                 radius={[10, 10, 0, 0]}
//                 isAnimationActive={false}
//               />
//             ))}
//           </BarChart>
//         </ResponsiveContainer>
//       </Paper>
//     </Box>
//   );
// };

// export default MonthlyComparisonChart;




// import React from 'react';
// import './barchart.css';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
// import { Paper, Typography, Box } from "@mui/material";

// const COLORS = [
//   "#1976d2", 
//   "#ef6c00", 
//   "#388e3c", 
//   "#d32f2f", 
//   "#7b1fa2", 
//   "#fbc02d", 
//   "#0097a7", 
//   "#5d4037", 
// ];

// const MonthlyComparisonChart = ({ data }) => {
//   // Financial year months in order (Apr to Mar)
//   const months = [
//     "April", "May", "June", "July", "August", "September",
//     "October", "November", "December", "January", "February", "March"
//   ];

//   // Define the years you want to display
//   const targetYears = [2025, 2026];  // Only show data for FY 2025-26, FY 2026-27

//   const uniqueYears = [...new Set(data.map(item => item.salesYear))]
//     .filter(year => targetYears.includes(year)) // Filter only the target years
//     .sort();

//   const transformData = (data) => {
//     const monthMap = {};

//     data.forEach((item) => {
//       const monthName = months[item.salesMonth - 1];

//       if (!monthMap[monthName]) {
//         monthMap[monthName] = { month: monthName };
//       }

//       // Include only the target years' data
//       if (targetYears.includes(item.salesYear)) {
//         monthMap[monthName][item.salesYear] = item.totalSales;
//       }
//     });

//     // Return months in financial year order
//     return months
//       .filter(m => monthMap[m])
//       .map(m => monthMap[m]);
//   };

//   const chartData = transformData(data);

//   return (
//     <Box sx={{ width: "100%" }}>
//       <Paper elevation={3} sx={{ p: 3, borderRadius: 2, boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
//         <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "#333" }}>
//           Sales Comparison
//         </Typography>

//         <ResponsiveContainer width="100%" height={300}>
//           <BarChart margin={{ left: 20, right: 20, bottom: 5 }} data={chartData}>
//             <XAxis
//               dataKey="month"
//               tick={{ fontSize: 12, fill: "#666" }}
//               tickLine={{ stroke: "#ddd" }}
//             />
//             <YAxis
//               ticks={[0, 200000, 400000, 1000000]}
//               domain={[0, 1000000]}
//               tickFormatter={(value) => value.toLocaleString('en-IN')}
//               tickLine={{ stroke: "#ddd" }}
//             />
//             <Tooltip
//               formatter={(value) => value.toLocaleString('en-IN')}
//               contentStyle={{ backgroundColor: "#fff", border: "1px solid #ccc", borderRadius: "5px" }}
//             />
//             <Legend
//               verticalAlign="top"
//               height={36}
//               iconType="circle"
//               wrapperStyle={{ lineHeight: "40px", fontSize: "12px", color: "#333" }}
//             />
//             {uniqueYears.map((year, index) => (
//               <Bar
//                 key={year}
//                 dataKey={year}
//                 fill={COLORS[index % COLORS.length]}
//                 name={`FY ${year}-${(year + 1).toString().slice(-2)}`}
//                 barSize={20}
//                 radius={[10, 10, 0, 0]}
//                 isAnimationActive={false}
//               />
//             ))}
//           </BarChart>
//         </ResponsiveContainer>
//       </Paper>
//     </Box>
//   );
// };

// export default MonthlyComparisonChart;


// import React from 'react';
// import './barchart.css';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
// import { Paper, Typography, Box } from "@mui/material";

// const COLORS = [
//   "#1976d2", 
//   "#ef6c00", 
//   "#388e3c", 
//   "#d32f2f", 
//   "#7b1fa2", 
//   "#fbc02d", 
//   "#0097a7", 
//   "#5d4037", 
// ];

// const MonthlyComparisonChart = ({ data }) => {
//   const months = [
//     "April", "May", "June", "July", "August", "September",
//     "October", "November", "December", "January", "February", "March"
//   ];

//   const targetYears = [2025, 2026];
//   const currentDate = new Date();
//   const currentYear = currentDate.getFullYear();
//   const currentMonthIndex = currentDate.getMonth(); 

//   const uniqueYears = [...new Set(data.map(item => item.salesYear))]
//     .filter(year => targetYears.includes(year)) 
//     .sort();

//   const transformData = (data) => {
//     const monthMap = {};

//     data.forEach((item) => {
//       const monthName = months[item.salesMonth - 1];
//       let salesYear = item.salesYear;
//       if (item.salesMonth === 1 || item.salesMonth === 2 || item.salesMonth === 3) {
//         salesYear = item.salesYear - 1;
//       }

//       if (!monthMap[monthName]) {
//         monthMap[monthName] = { month: monthName };
//       }

//       if (targetYears.includes(salesYear)) {
//         monthMap[monthName][salesYear] = item.totalSales;
//       }
//     });

//     return months
//       .filter((month, index) => {
//         if (currentYear === 2025 && index > currentMonthIndex) {
//           return false; 
//         }
//         return currentYear === 2025 || (currentYear === 2026 && index < 12);
//       })
//       .map((month) => {
//         return monthMap[month] || { month, 2025: 0, 2026: 0 }; 
//       });
//   };

//   const chartData = transformData(data);

//   return (
//     <Box sx={{ width: "100%" }}>
//       <Paper elevation={3} sx={{ p: 3, borderRadius: 2, boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
//         <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "#333" }}>
//           Sales Comparison
//         </Typography>

//         <ResponsiveContainer width="100%" height={300}>
//           <BarChart margin={{ left: 20, right: 20, bottom: 5 }} data={chartData}>
//             <XAxis
//               dataKey="month"
//               tick={{ fontSize: 12, fill: "#666" }}
//               tickLine={{ stroke: "#ddd" }}
//             />
//             <YAxis
//               ticks={[0, 200000, 400000, 600000, 800000, 1000000, 1200000]}
//               domain={[0, 1000000]}
//               tickFormatter={(value) => value.toLocaleString('en-IN')}
//               tickLine={{ stroke: "#ddd" }}
//             />
//             <Tooltip
//               formatter={(value) => value.toLocaleString('en-IN')}
//               contentStyle={{ backgroundColor: "#fff",  borderRadius: "5px" }}
//             />
//             <Legend
//               verticalAlign="top"
//               height={36}
//               iconType="circle"
//               wrapperStyle={{ lineHeight: "40px", fontSize: "12px", color: "#333" }}
//             />
//             {uniqueYears.map((year, index) => (
//               <Bar
//                 key={year}
//                 dataKey={year}
//                 fill={COLORS[index % COLORS.length]}
//                 name={`FY ${year}-${(year + 1).toString().slice(-2)}`}
//                 barSize={20}
//                 radius={[10, 10, 0, 0]}
//                 isAnimationActive={true}
//               />
//             ))}
//           </BarChart>
//         </ResponsiveContainer>
//       </Paper>
//     </Box>
//   );
// };

// export default MonthlyComparisonChart;


import React from 'react';
import './barchart.css';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Paper, Typography, Box } from "@mui/material";

// Reverted back to original colors
const COLORS = ["#5c6bc0", "#ff7043", "#66bb6a", "#f44336", "#ab47bc", "#ffeb3b", "#00acc1", "#8d6e63"];

const MonthlyComparisonChart = ({ data }) => {
  const months = [
    "April", "May", "June", "July", "August", "September", 
    "October", "November", "December", "January", "February", "March"
  ];

  const uniqueYears = [
    ...new Set(
      data.map(item => parseInt(item.fY_YEAR.split('-')[0].slice(2)))  
    )
  ].sort();

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonthIndex = currentDate.getMonth(); 

  const standardizeMonthName = (month) => {
    const monthMapping = {
      "Jan": "January", "Feb": "February", "Mar": "March", "Apr": "April", "May": "May", "Jun": "June", 
      "Jul": "July", "Aug": "August", "Sep": "September", "Oct": "October", "Nov": "November", "Dec": "December"
    };
    return monthMapping[month] || month;  
  };

  const transformData = (data) => {
    const monthMap = {};

    data.forEach((item) => {
      const monthName = standardizeMonthName(item.month); 
      let salesYear = parseInt(item.fY_YEAR.split('-')[0].slice(2)); 

      if (item.month === "January" || item.month === "February" || item.month === "March") {
        salesYear -= 1; 
      }

      if (!monthMap[monthName]) {
        monthMap[monthName] = { month: monthName }; 
      }

      if (uniqueYears.includes(salesYear)) {
        monthMap[monthName][salesYear] = item.total_sales;
      }
    });

    return months.map((month) => {
      return monthMap[month] || {
        month, 
        ...uniqueYears.reduce((acc, year) => ({ ...acc, [year]: 0 }), {}) 
      };
    });
  };

  const chartData = transformData(data); 

  // Custom tooltip formatter for differentiating year data
  const customTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd' }}>
          <p style={{ margin: 0, fontWeight: 600 }}>{label}</p>
          {payload.map((entry, index) => (
            <p key={index} style={{ color: COLORS[index % COLORS.length], margin: '5px 0' }}>
              {`FY ${uniqueYears[index]}-${(uniqueYears[index] + 1).toString().slice(-2)}: `}
              <strong>{entry.value.toLocaleString('en-IN')}</strong>
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Paper elevation={4} sx={{ p: 3, borderRadius: 2, boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.1)" }}>
        <Typography variant="h6" gutterBottom sx={{ fontSize: "16px" ,fontWeight: 600, color: "#333", marginBottom: 2 }}>
          Sales Comparison
        </Typography>

        <ResponsiveContainer width="100%" height={350}>
          <BarChart margin={{ left: 20, right: 20, bottom: 10 }} data={chartData}>
            <XAxis
              dataKey="month"
              tick={{ fontSize: 10, fill: "#444", fontFamily: "'Roboto', sans-serif" }}
              tickLine={{ stroke: "#ddd" }}
            />
            <YAxis
              ticks={[0, 200000, 400000, 600000, 800000, 1000000, 1200000]}
              domain={[0, 1200000]}
              tickFormatter={(value) => value.toLocaleString('en-IN')}
              tickLine={{ stroke: "#ddd" }}
            />
            <Tooltip
              content={customTooltip} 
            />
            <Legend
              verticalAlign="top"
              height={36}
              iconType="circle"
              wrapperStyle={{ lineHeight: "40px", fontSize: "14px", color: "#333" }}
            />
            {uniqueYears.map((year, index) => (
              <Bar
                key={year}
                dataKey={year}
                fill={COLORS[index % COLORS.length]} 
                name={`FY ${year}-${(year + 1).toString().slice(-2)}`}
                barSize={22}
                radius={[12, 12, 0, 0]}
                isAnimationActive={true}
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </Paper>
    </Box>
  );
};

export default MonthlyComparisonChart;


// import React from 'react';
// import './barchart.css';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
// import { Paper, Typography, Box } from "@mui/material";

// // Colors for each bar
// const COLORS = [
//   "#1976d2", 
//   "#ef6c00", 
//   "#388e3c", 
//   "#d32f2f", 
//   "#7b1fa2", 
//   "#fbc02d", 
//   "#0097a7", 
//   "#5d4037", 
// ];

// const MonthlyComparisonChart = () => {
//   const months = [
//     "Apr", "May", "Jun", "Jul", "Aug", "Sep",
//     "Oct", "Nov", "Dec", "Jan", "Feb", "Mar"
//   ];

//   const data = [
//     { month: "Aug", FYYear: "FY2025-2026", totalSales: 121232.07 },
//     { month: "Jun", FYYear: "FY2025-2026", totalSales: 1053657.15 },
//     { month: "Dec", FYYear: "FY2025-2026", totalSales: 546989.24 },
//     { month: "Apr", FYYear: "FY2025-2026", totalSales: 113993.47 },
//     { month: "Jul", FYYear: "FY2025-2026", totalSales: 121693.02 },
//     { month: "Jan", FYYear: "FY2025-2026", totalSales: 226232.24 },
//     { month: "Apr", FYYear: "FY2026-2027", totalSales: 673533.10 },
//     { month: "Sep", FYYear: "FY2025-2026", totalSales: 947473.22 },
//     { month: "Nov", FYYear: "FY2025-2026", totalSales: 362432.31 },
//     { month: "May", FYYear: "FY2025-2026", totalSales: 149483.42 },
//     { month: "May", FYYear: "FY2026-2027", totalSales: 179443.42 },
//     { month: "Mar", FYYear: "FY2025-2026", totalSales: 210323.00 }
//   ];

//   const targetYears = [2025, 2026];

//   const currentDate = new Date();
//   const currentYear = currentDate.getFullYear();
//   const currentMonthIndex = currentDate.getMonth(); 

//   const uniqueYears = [...new Set(data.map(item => parseInt(item.FYYear.split('-')[0].slice(2))))] 
//     .filter(year => targetYears.includes(year))
//     .sort();

//   const transformData = (data) => {
//     const monthMap = {};

//     data.forEach((item) => {
//       const monthName = item.month; 
//       const salesYear = parseInt(item.FYYear.split('-')[0].slice(2)); 

//       if (!monthMap[monthName]) {
//         monthMap[monthName] = { month: monthName };
//       }

//       if (targetYears.includes(salesYear)) {
//         monthMap[monthName][salesYear] = item.totalSales;
//       }
//     });

//     return months.map((month) => {
//       return monthMap[month] || { month, 2025: 0, 2026: 0 }; 
//     });
//   };

//   const chartData = transformData(data);

//   return (
//     <Box sx={{ width: "100%" }}>
//       <Paper elevation={3} sx={{ p: 3, borderRadius: 2, boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
//         <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "#333" }}>
//           Sales Comparison
//         </Typography>

//         <ResponsiveContainer width="100%" height={300}>
//           <BarChart margin={{ left: 20, right: 20, bottom: 5 }} data={chartData}>
//             <XAxis
//               dataKey="month"
//               tick={{ fontSize: 12, fill: "#666" }}
//               tickLine={{ stroke: "#ddd" }}
//             />
//             <YAxis
//               ticks={[0, 200000, 400000, 600000, 800000, 1000000, 1200000]}
//               domain={[0, 1000000]}
//               tickFormatter={(value) => value.toLocaleString('en-IN')}
//               tickLine={{ stroke: "#ddd" }}
//             />
//             <Tooltip
//               formatter={(value) => value.toLocaleString('en-IN')}
//               contentStyle={{ backgroundColor: "#fff",  borderRadius: "5px" }}
//             />
//             <Legend
//               verticalAlign="top"
//               height={36}
//               iconType="circle"
//               wrapperStyle={{ lineHeight: "40px", fontSize: "12px", color: "#333" }}
//             />
//             {uniqueYears.map((year, index) => (
//               <Bar
//                 key={year}
//                 dataKey={year}
//                 fill={COLORS[index % COLORS.length]}
//                 name={`FY ${year}-${(year + 1).toString().slice(-2)}`}
//                 barSize={20}
//                 radius={[10, 10, 0, 0]}
//                 isAnimationActive={true}
//               />
//             ))}
//           </BarChart>
//         </ResponsiveContainer>
//       </Paper>
//     </Box>
//   );
// };

// export default MonthlyComparisonChart;